module.exports = __webpack_public_path__ + "img/gaba.d0289dc0.png";